import loadable from '@loadable/component';

export const OrgDashboardViewListingApplicationPageContainerLoadable = loadable(
  () => import('./OrgDashboardViewListingApplicationPageContainer'),
  {
    resolveComponent: (module) =>
      module.OrgDashboardViewListingApplicationPageContainer,
  },
);
